import React from "react"
import logoWhite from "../../../images/arden-university-white.png"
import footerStyle from "./footer.module.css"
const Footer = () => (
  <footer className={footerStyle.webinarfooter}>
    <img src={logoWhite} />
    <p>© {new Date().getFullYear()} Arden University. All rights reserved.</p>
  </footer>
)

export default Footer
